import { Row, Col, Button, Image } from 'react-bootstrap';

import openJobs from './openPositions.js';


function OpenJobsList() {
   const openPositionsAvailable = areOpenPositionsAvailable();
   if(openPositionsAvailable) {
    var counter=0;
    return (
        <div>
            {openJobs.map(job => (
                <Row className='py-3' id={'job-' + counter++}>
                    <Col className='jobPosition'>
                        <h2><u>{job.title}</u></h2>
                        <p>{job.teaser1}</p>
                        <h3>{job.captionTasks}</h3>
                        <ul className='joblist'>
                            {job.tasks.map(task => (
                                <li>{task}</li>
                            ))}
                        </ul>

                        <h3>Was Du mitbringen solltest</h3>
                        <ul className='joblist'>
                            {job.lookingFor.map(lookingFor => (
                                <li>{lookingFor}</li>
                            ))}
                        </ul>

                        <h3>{job.captionBeneftis}</h3>
                        <ul className='joblist'>
                            {job.benefits.map(benefit => (
                                <li>{benefit}</li>
                            ))}
                        </ul>

                        <p>{job.teaser2}</p>
                        <hr className='manHr'/>
                    </Col>
                </Row>
            ))}
        </div>
   );
   }

   return (
    <Row>
        <Col>
        <h4>Zur Zeit sind keine Stellen ausgeschrieben.</h4></Col>
    </Row>
   );
}

function areOpenPositionsAvailable() {
    return openJobs.length > 0;
}

export default OpenJobsList;